module.exports = __webpack_public_path__ + "img/sign-50.ad6bbf7f.jpg";